var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useRef, useState, } from 'react';
import Cookies from 'js-cookie';
import { Sidebar, createTheme } from '@michelin/acid-components';
import { Badge } from '@material-ui/core';
import { makeStyles, createStyles, ThemeProvider } from '@material-ui/core/styles';
import { AppsMenu } from '../AppsMenu/AppsMenu';
import { CentralProviderContext, LegalDocsContext } from '../../centralProviderContext/CentralProviderContext';
import { useLegalDocuments } from '../../hooks/useLegalDocuments';
import { appsMenuTheme, badgeSidebarTheme } from '../../styles/scopedThemes';
var useBadgeStyles = makeStyles(function (theme) { return createStyles({
    sidebarRoot: {
        '& [class*="--selected"]': {
            filter: 'none !important',
        },
    },
    iconBadge: {
        '& .MuiBadge-badge': {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
            fontSize: '0.65rem',
            fontWeight: 600,
            minWidth: 18,
            height: 18,
            borderRadius: 9,
        },
    },
    rightBadge: {
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 18,
        height: 18,
        borderRadius: 9,
        backgroundColor: theme.palette.error.main,
        color: theme.palette.common.white,
        fontSize: '0.65rem',
        fontWeight: 600,
        padding: '0 4px',
    },
}); });
// eslint-disable-next-line no-redeclare
function CentralProviderBadgeSidebar(props) {
    var initial = !!Cookies.get('sidebar-minimized');
    var _a = __read(useState(!initial), 2), sidebarOpen = _a[0], setSidebarOpen = _a[1];
    var _b = __read(useState(''), 2), execute = _b[0], setExecute = _b[1];
    var ref = useRef(null);
    var setSidebarRef = useContext(CentralProviderContext).setSidebarRef;
    var getSalesForceTermsLink = useLegalDocuments().getSalesForceTermsLink;
    var legalContext = React.useContext(LegalDocsContext);
    var classes = useBadgeStyles();
    var onShrink = props.onShrink, onGrow = props.onGrow, _c = props.showApplicationSelector, showApplicationSelector = _c === void 0 ? true : _c, _d = props.items, items = _d === void 0 ? [] : _d;
    var handlerSidebarMovement = function (e) {
        if (e === undefined)
            return;
        setSidebarOpen(e);
    };
    var onSidebarShrink = function (e) {
        handlerSidebarMovement(e);
        if (onShrink)
            onShrink(e);
    };
    var onSidebarGrow = function (e) {
        handlerSidebarMovement(e);
        if (onGrow)
            onGrow(e);
    };
    useEffect(function () {
        if (ref && ref.current) {
            setSidebarRef(ref);
        }
        legalContext.showLegalDocs(props.showLegalInformation || false);
    }, [ref]);
    // unmount
    useEffect(function () { return function () { return setSidebarRef(null); }; }, []);
    var openSidebar = function () {
        var d = new Date();
        setExecute(d.toString());
    };
    var transformedItems = items.map(function (item) {
        var hasBadge = (item.badge && item.badge > 0);
        if (!hasBadge || !item.icon)
            return item;
        var badgeContent = item.badge || '!';
        if (sidebarOpen) {
            var wrappedIcon_1 = (React.createElement(React.Fragment, null,
                item.icon,
                React.createElement("span", { className: classes.rightBadge }, badgeContent)));
            return __assign(__assign({}, item), { icon: wrappedIcon_1 });
        }
        var wrappedIcon = (React.createElement(Badge, { badgeContent: badgeContent, className: classes.iconBadge }, item.icon));
        return __assign(__assign({}, item), { icon: wrappedIcon });
    });
    return (React.createElement(ThemeProvider, { theme: createTheme({ palette: badgeSidebarTheme }) },
        React.createElement("div", { className: classes.sidebarRoot },
            React.createElement(Sidebar, __assign({}, props, { items: transformedItems, onShrink: onSidebarShrink, onGrow: onSidebarGrow, execute: execute, onLegalLinkClick: function (doc) { return window.open(getSalesForceTermsLink(doc), '_blank'); } }), showApplicationSelector
                && (React.createElement("div", { id: "central-provider-sidebar", ref: ref, style: {
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '14px 0',
                        width: '100%',
                    } },
                    React.createElement(ThemeProvider, { theme: createTheme({ palette: appsMenuTheme }) },
                        React.createElement(AppsMenu, { small: !sidebarOpen, onClickWhenSmall: openSidebar }))))))));
}
CentralProviderBadgeSidebar.defaultProps = {
    variant: 'permanent',
    open: true,
    title: '',
    drawerWidth: 240,
    items: [],
    versions: [],
    rememberMinifiedStatus: true,
    position: 'top',
    showLegalInformation: false,
    showCopyright: false,
};
export default CentralProviderBadgeSidebar;
//# sourceMappingURL=CentralProviderBadgeSidebar.js.map